"use client";
import { useState } from "react";
import HeaderInner from "../../utility/HeaderInner";
import { FaImage } from "react-icons/fa";
import { AwardsData } from "../../utility/AwardsData";

const Awards = () => {
  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <div className="mt-70">
      <HeaderInner title="Awards" />
      <section className="py-5 bg-light">
        <div style={{ paddingLeft: 30, paddingRight: 30 }}>
          {/* Grid */}
          <div className="row g-3">
            {AwardsData.map((item, index) => (
              <div key={index} className="col-12 col-sm-6 col-md-2">
                <div
                  className="card overflow-hidden shadow-sm position-relative"
                  onClick={() => setSelectedItem(item)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={item.src}
                    alt={item.title}
                    className="card-img-top object-fit-contain"
                    style={{ height: "14rem" }}
                  />
                  <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 opacity-0 hover-opacity-100 transition">
                    <FaImage className="text-white fs-2" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedItem && (
        <div
          className="modal d-block fade show"
          tabIndex="-1"
          role="dialog"
          onClick={() => setSelectedItem(null)}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content bg-transparent border-0">
              <button
                type="button"
                className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
                aria-label="Close"
                onClick={() => setSelectedItem(null)}
              ></button>

              <div className="modal-body p-0">
                <img
                  src={selectedItem.src}
                  alt="Gallery"
                  className="img-fluid rounded mx-auto d-block"
                  style={{ maxHeight: "80vh", objectFit: "contain" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .hover-opacity-100:hover {
          opacity: 1 !important;
        }
        .transition {
          transition: all 0.3s ease;
        }
      `}</style>
    </div>
  );
};

export default Awards;
